export default {"src":"/_next/static/image/public/images/flags/flag_502.1df9b88a3f8e4b4adac3addaf0fb1086.svg","height":16,"width":24};